<template>
  <header class="header">
    <div class="header__logo">
      <a href="#" target="_blank">
        <img src="./../../assets/images/hrdesk-logo-dark-beta.png" alt="logo" />
      </a>
    </div>
    <div class="header__nav">
      <!--
        <font-awesome-icon icon="phone-alt" />&nbsp;Talk with our team at:
      <span>(234) 706 340 8068</span>
      -->
    </div>
  </header>
</template>

<script>
export default {
  name: "OnboardHeader",
  data() {
    return {
      userName: "Loading",
    };
  },
};
</script>

<style lang="scss" scoped>
.header {
  // min-width: 1000px;
  height: 80px;
  padding: 10px 7.188vw;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  align-content: center;

  @media (max-width: 500px) {
    flex-direction: column;
  }

  >.header__logo {
    max-width: 150px;
    padding-top: 0;

    >a {
      img {
        width: 100%;
      }
    }
  }

  >.header__nav {
    width: calc(100% - 179px);
    font-size: 14px;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: right;
    color: #000000;

    @media (max-width: 500px) {
      width: 100%;
      text-align: center;
      font-size: 12px;
    }

    >span {
      font-weight: normal;
      color: #5099de;
    }
  }
}
</style>
